<template>
  <div class="mt-component-form print-container mb-4">
    <vs-row class="my-4 center-flex">
      <h5><i class="dot"></i>{{ $t(title) }}</h5>
      <div class="ml-auto">
        <vs-button v-if="!isPrint" color="secondary" @click="handleAddRow">{{ $t('항목추가') }}</vs-button>
        <vs-button v-if="!isPrint" class="ml-4" color="secondary" type="border" @click="handleRemoveRow">{{ $t('선택삭제') }}</vs-button>
      </div>
    </vs-row>

    <div class="w-full" style="overflow-x: scroll">
      <!--    head-->
      <div
        class="grid row-header border-left"
        style="font-weight: 700"
        :style="
          !isPrint
            ? 'grid-template-columns: 66px 170px 320px 92px 120px 92px 50px 50px 92px 92px 640px 70px 70px 70px 80px 624px 400px'
            : 'grid-template-columns: 170px 320px 92px 120px 92px 50px 50px 92px 92px 640px 70px 70px 70px 80px 624px 400px'
        "
      >
        <div v-if="!isPrint" class="row-header__item border-right">
          <vs-checkbox v-model="tableAllCheck" @change="changeAllCheck"></vs-checkbox>
        </div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">{{ $t('팀명') }}</div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">{{ $t('물질명') }}<br />(제품명)</div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">{{ $t('취급량') }}<br />(L/월)</div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">{{ $t('사용 빈도') }}<br />(시간/월)</div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">{{ $t('취급빈도') }}<br />(회/월)</div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">{{ $t('위험') }}<br />물질</div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">{{ $t('유해') }}<br />물질</div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">{{ $t('사용작업내용') }}</div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">{{ $t('사용용도') }}<br />(위치)</div>
        <div class="row-header__item border-right" style="background-color: #f0f0fd">
          <div class="w-full h-full" style="display: grid; grid-template-rows: 1fr 1fr; align-items: center">
            <div class="h-full border-bottom" style="display: grid; align-items: center">{{ $t('구성성분 및 함유량') }}</div>
            <div class="h-full grid" style="grid-template-columns: 200px 320px 120px">
              <span class="border-right" style="display: grid; align-items: center">{{ $t('CAS번호') }}</span>
              <span class="border-right" style="display: grid; align-items: center">{{ $t('구성성분') }}</span>
              <span style="display: grid; align-items: center">{{ $t('함유량') }}<br />(%)</span>
            </div>
          </div>
        </div>
        <div class="row-header__item border-right" style="background-color: #f0f0fd">{{ $t('작업환경') }}<br />측정</div>
        <div class="row-header__item border-right" style="background-color: #f0f0fd">{{ $t('특수건강') }}<br />진단</div>
        <div class="row-header__item border-right" style="background-color: #f0f0fd">{{ $t('특검주기') }}</div>
        <div class="row-header__item border-right" style="background-color: #f0f0fd">{{ $t('물질구분(관리대상/특별)') }}</div>
        <div class="row-header__item border-right" style="display: grid; grid-template-rows: 1fr 1fr; background-color: #f9f9f9">
          <div class="h-full border-bottom" style="display: grid; align-items: center">{{ $t('관리상태') }}</div>
          <div class="h-full grid" style="grid-template-columns: repeat(7, 70px) 134px">
            <span class="border-right" style="display: grid; align-items: center">MSDS<br />게시</span>
            <span class="border-right" style="display: grid; align-items: center">MSDS<br />관리요령<br />게시</span>
            <span class="border-right" style="display: grid; align-items: center">{{ $t('경고표지') }}<br />부착</span>
            <span class="border-right" style="display: grid; align-items: center">MSDS<br />교육</span>
            <span class="border-right" style="display: grid; align-items: center">{{ $t('특별교육') }}</span>
            <span class="border-right" style="display: grid; align-items: center">{{ $t('적정보호구 지급') }}</span>
            <span class="border-right" style="display: grid; align-items: center">{{ $t('특수건강진단 실시') }}</span>
            <span style="display: grid; align-items: center">{{ $t('변동사항') }}</span>
          </div>
        </div>
        <div class="row-header__item border-right" style="background-color: #f9f9f9">{{ $t('비고') }}</div>
      </div>

      <!-- rows -->
      <draggable class="w-full" :list="tableList" handle=".handle">
        <div
          class="w-full grid row-content border-left"
          :style="
            !isPrint
              ? 'grid-template-columns: 66px 170px 320px 92px 120px 92px 50px 50px 92px 92px 200px 320px 120px 70px 70px 70px 80px repeat(7, 70px) 134px 400px'
              : 'grid-template-columns: 170px 320px 92px 120px 92px 50px 50px 92px 92px 200px 320px 120px 70px 70px 70px 80px repeat(7, 70px) 134px 400px'
          "
          v-for="(rows, indexRows) in tableList"
          :key="indexRows"
        >
          <div v-if="!isPrint" class="none-border-center border-right border-bottom h-full">
            <feather-icon class="handle mr-4 ml-2" icon="MenuIcon" style="width: 14px; height: 14px; cursor: pointer" />
            <vs-checkbox v-model="rows.is_checked"></vs-checkbox>
          </div>

          <!-- 팀명 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.팀명" class="w-full flex-1 p-1" placeholder="예)청사관리"/>
            <span v-else class="print-input">{{ rows.팀명 }}</span>
          </div>

          <!-- 물질명(제품명) -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.물질명" class="w-full flex-1 p-1" placeholder="입력"/>
            <span v-else class="print-input">{{ rows.물질명 }}</span>
          </div>

          <!-- 취급량(L/월) -->
          <div class="item-area p-1 border-right border-bottom h-full" style="align-self: center">
            <div v-if="!isPrint" class="flex-1 flex items-center">
              <ml-input rows="1" v-model="rows.취급량" class="w-full flex-1 p-1" placeholder="입력"/>
              <span class="px-1">L</span>
            </div>
            <span v-else class="print-input">{{ rows.취급량 }}L</span>
          </div>

          <!-- 사용빈도(시간/월) -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <div v-if="!isPrint" class="flex-1 flex items-center">
              <ml-input rows="1" v-model="rows.사용빈도" class="w-full flex-1 p-1" placeholder="입력"/>
              <span class="px-1">{{ $t('시간') }}</span>
            </div>
            <span v-else class="print-input">{{ rows.사용빈도 }}시간</span>
          </div>

          <!-- 취급빈도(회/월) -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <div v-if="!isPrint" class="flex-1 flex items-center">
              <ml-input rows="1" v-model="rows.취급빈도" class="w-full flex-1 p-1" placeholder="입력"/>
              <span class="px-1">회</span>
            </div>
            <span v-else class="print-input">{{ rows.취급빈도 }}회</span>
          </div>

          <!-- 위험물질 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.위험물질"></vs-checkbox>
            <span v-else class="print-input">{{ rows.위험물질 }}</span>
          </div>

          <!-- 유해물질 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.유해물질"></vs-checkbox>
            <span v-else class="print-input">{{ rows.유해물질 }}</span>
          </div>

          <!-- 사용작업내용 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.사용작업내용" class="w-full flex-1 p-1" placeholder="입력"/>
            <span v-else class="print-input">{{ rows.사용작업내용 }}</span>
          </div>

          <!-- 사용작업내용 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <div v-if="!isPrint" class="flex-1 flex items-center">
              <ml-input rows="1" v-model="rows.사용용도" class="w-full flex-1 p-1" placeholder="입력"/>
              <span class="px-1">{{ $t('(위치)') }}</span>
            </div>
            <span v-else class="print-input">{{ rows.사용용도 }}(위치)</span>
          </div>

          <!-- CAS번호 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.CAS번호" class="w-full flex-1 p-1" placeholder="입력"/>
            <span v-else class="print-input">{{ rows.CAS번호 }}</span>
          </div>

          <!-- 구성성분 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.구성성분" class="w-full flex-1 p-1" placeholder="입력"/>
            <span v-else class="print-input">{{ rows.구성성분 }}</span>
          </div>

          <!-- 함유량(%) -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <div v-if="!isPrint" class="flex-1 flex items-center">
              <ml-input rows="1" v-model="rows.함유량" class="w-full flex-1 p-1" placeholder="30~40"/>
              <span class="px-1">%</span>
            </div>
            <span v-else class="print-input">{{ rows.함유량 }}%</span>
          </div>

          <!-- 작업환경측정 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.작업환경측정" class="w-full flex-1 p-1" placeholder="입력"/>
            <span v-else class="print-input">{{ rows.작업환경측정 }}</span>
          </div>

          <!-- 특수건강진단 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.특수건강진단" class="w-full flex-1 p-1" placeholder="입력"/>
            <span v-else class="print-input">{{ rows.특수건강진단 }}</span>
          </div>

          <!-- 특검주기 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.특검주기" class="w-full flex-1 p-1" placeholder="입력"/>
            <span v-else class="print-input">{{ rows.특검주기 }}</span>
          </div>

          <!-- 물질구분(관리대상/특별) -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.물질구분" class="w-full flex-1 p-1" placeholder="입력"/>
            <span v-else class="print-input">{{ rows.물질구분 }}</span>
          </div>

          <!-- MSDS게시 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.MSDS게시"></vs-checkbox>
            <span v-else class="print-input">{{ rows.MSDS게시 }}</span>
          </div>

          <!-- MSDS관리요령게시 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.MSDS관리요령게시"></vs-checkbox>
            <span v-else class="print-input">{{ rows.MSDS관리요령게시 }}</span>
          </div>

          <!-- 경고표지부착 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.경고표지부착"></vs-checkbox>
            <span v-else class="print-input">{{ rows.경고표지부착 }}</span>
          </div>

          <!-- MSDS교육 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.MSDS교육"></vs-checkbox>
            <span v-else class="print-input">{{ rows.MSDS교육 }}</span>
          </div>

          <!-- 특별교육 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.특별교육"></vs-checkbox>
            <span v-else class="print-input">{{ rows.특별교육 }}</span>
          </div>

          <!-- 적정보호구지급 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.적정보호구지급"></vs-checkbox>
            <span v-else class="print-input">{{ rows.적정보호구지급 }}</span>
          </div>

          <!-- 특수건강진단실시 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center">
            <vs-checkbox v-if="!isPrint" v-model="rows.특수건강진단실시"></vs-checkbox>
            <span v-else class="print-input">{{ rows.특수건강진단실시 }}</span>
          </div>

          <!-- 변동사항 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.변동사항" class="w-full flex-1 p-1" placeholder="입력"/>
            <span v-else class="print-input">{{ rows.변동사항 }}</span>
          </div>

          <!-- 비고 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.비고" class="w-full flex-1 p-1" placeholder="입력"/>
            <span v-else class="print-input">{{ rows.비고 }}</span>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "MsdsModule",
  components: {
    draggable,
  },
  props: {
    title: {
      type: String,
      default: () => "MSDS",
    },
    colTitle_1: String,
    colTitle_2: String,
    colTitle_3: String,
    colTitle_4: String,
    value: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.length > 0) {
          this.tableList = value;
        }
      },
    },
    tableList(value) {
      this.$emit("input", value);
    },
  },
  methods: {
    checkForm(value, indexRows, text) {
      if (value.target.checked) {
        this.$emit("update-list-check", indexRows - 1, text);
      } else {
        this.$emit("update-list-check", indexRows - 1, "");
      }
    },
    // 항목추가
    handleAddRow() {
      this.tableList.push({
        is_checked: this.tableAllCheck,
        팀명: "",
        물질명: "",
        취급량: "",
        사용빈도: "",
        취급빈도: "",
        위험물질: "",
        유해물질: "",
        사용작업내용: "",
        사용용도: "",
        CAS번호: "",
        구성성분: "",
        함유량: "",
        작업환경측정: "",
        특수건강진단: "",
        특검주기: "",
        물질구분: "",
        MSDS게시: "",
        MSDS관리요령게시: "",
        경고표지부착: "",
        MSDS교육: "",
        특별교육: "",
        적정보호구지급: "",
        특수건강진단실시: "",
        변동사항: "",
        비고: "",
      });
      this.updateList();
    },
    // 선택삭제
    handleRemoveRow() {
      for (let i = 0; i < this.tableList.length; i++) {
        if (this.tableList[i].is_checked) {
          this.tableList.remove(this.tableList[i]);
          i = -1;
        }
      }

      this.tableAllCheck = false;
      this.updateList();
    },
    // 일괄 체크
    changeAllCheck() {
      for (const data of this.tableList) {
        data.is_checked = this.tableAllCheck;
      }
    },
    // update
    updateList() {
      this.$emit("updateList", this.tableList);
    },
  },
  data() {
    return {
      tableAllCheck: false,
      tableList: [],
    };
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  border-left: none;
  border-right: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
